module.exports = __webpack_public_path__ + "media/images/frontend/arrow_down-a09f64e6e2615c5ff830bc9f52d6d5d1.svg";